import { USER_SUCCESS } from "../../constants";

const mutations = {
	[USER_SUCCESS]: (state, user) => {
		state.user = user;
	},
};

export default mutations;
